import React, {useContext} from 'react'
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {useRouteMatch} from "react-router-dom";
import {AdminContext} from "v4/contexts/AdminContext";
import ProductConfigurationsList from "v4/pages/admin/ProductConfigurations/ProductConfigurationsList/ProductConfigurationsList";
import ProductConfigurationsForm from "v4/pages/admin/ProductConfigurations/ProductConfigurationsForm/ProductConfigurationsForm";
export default function ProductConfigurationsPage() {
    const {t} = usePolTranslation();
    const {path, params: {id}, isExact} = useRouteMatch();
    const isAddPage = path.split('/').pop() === 'add';
    const isEditPage = !!id && isExact;
    const isListPage = (!isAddPage && !isEditPage);
    const {asCustomer} = useContext(AdminContext);
    const getComponent = () => {
        if (isListPage) {
            return <ProductConfigurationsList customerId={asCustomer?.id}/>
        }
        return <ProductConfigurationsForm id={id} customerId={asCustomer?.id}/>
    }
    return (
        <>
            {asCustomer?.id ?
                (
                    <>
                        {getComponent()}
                    </>
                ) : (
                    <p>{t('no_customer_defined')}</p>
                )
            }
        </>
    )
}